import React, { Component } from 'react'
import { connect } from 'react-redux'
import Search from '../components/Search'
import Header from '../components/Header'
import CallToActionBar from '../components/CallToActionBar'
import { Container, Accordion } from 'react-bootstrap'
import FaqItem from '../components/FaqItem'

const SearchResults = ({ query, searchResults, brand }) => (
	<>
		<h2 className="text-left">Gevonden voor '{query}'</h2>
		<Accordion>
			{searchResults.map(item => (
				<FaqItem key={item.nodeId} item={item} brand={brand} />
			))}
		</Accordion>
	</>
)

const NoResults = ({ query }) => (
	<>
		<h2 className="text-left">Geen resultaten gevonden</h2>
		<p>
			Helaas, uw zoekterm <strong>"{query}"</strong> heeft geen resultaten opgelevert. Probeer het
			nog eens met een andere term of neem contact met ons op via onderstaande manieren.
		</p>
	</>
)

class Results extends Component {
	state = {
		loading: true,
	}

	componentDidMount() {
		this.getAnswers()
	}

	componentDidUpdate(prevProps) {
		if (
			prevProps.answers !== this.props.answers ||
			prevProps.location.pathname !== this.props.location.pathname
		) {
			this.getAnswers()
		}
	}

	getAnswers() {
		const { query } = this.props.match.params
		const { answers } = this.props
		if (answers) {
			const filteredAnswers = answers.filter(answer => {
				if (answer.solutionText.includes(query) || answer.displayText.includes(query)) {
					return answer
				} else {
					return false
				}
			})
			this.setState({ searchResults: filteredAnswers, query })
		}
	}

	render() {
		const { brand } = this.props
		const { searchResults, query } = this.state

		return (
			<>
				<Header search={query} />
				<Search prefill={query} brand={brand} />
				{searchResults && searchResults.length > 0 ? (
					<section className="block-section faq">
						<Container>
							<SearchResults
								query={query}
								searchResults={searchResults}
								brand={brand}></SearchResults>
						</Container>
					</section>
				) : (
					<section className="block-section faq">
						<Container>
							<NoResults query={query}></NoResults>
						</Container>
					</section>
				)}

				<CallToActionBar brand={brand} />
			</>
		)
	}
}

const mapStateToProps = state => ({
	answers: state.knowledgeBase.knowledgeBaseFlatList,
})

export default connect(mapStateToProps)(Results)
